const MAP = {
  HAUTE: "bg-rose-500/10 text-rose-600 border-rose-200 dark:bg-rose-500/20 dark:text-rose-400 dark:border-rose-800",
  MOYENNE: "bg-amber-500/10 text-amber-600 border-amber-200 dark:bg-amber-500/20 dark:text-amber-400 dark:border-amber-800",
  BASSE: "bg-emerald-500/10 text-emerald-600 border-emerald-200 dark:bg-emerald-500/20 dark:text-emerald-400 dark:border-emerald-800",
};

export default function PriorityBadge({ level, className = "" }) {
  const lvl = (level || "MOYENNE").toUpperCase();
  const cls = MAP[lvl] || MAP.MOYENNE;
  return (
    <span
      data-testid={`priority-badge-${lvl.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${cls} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" /> {lvl}
    </span>
  );
}
